import { render } from "./FormRow.vue?vue&type=template&id=053ba09f&scoped=true"
import script from "./FormRow.vue?vue&type=script&lang=js"
export * from "./FormRow.vue?vue&type=script&lang=js"

import "./FormRow.vue?vue&type=style&index=0&id=053ba09f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053ba09f"]])

export default __exports__